import React from "react";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { Link } from "react-router-dom";
import Scroll from 'react-scroll'
import tubers from './Enflate.svg'
import { HashLink } from "react-router-hash-link";
// reactstrap components
import {
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Button,
  Container,
  UncontrolledTooltip,
} from "reactstrap";


const ScrollLink = Scroll.ScrollLink
function ExamplesNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} color="info" expand="lg">
        <Container>
        
          <div className="navbar-translate">
            <NavbarBrand>
            <HashLink smooth offset={() => 100} style={{fontSize:'12px',textDecoration:'none'}} to='/'><img src={tubers} style={{width:'160px',padding:'0px 5px'}}></img></HashLink>
            </NavbarBrand>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              <NavItem>
              <UncontrolledDropdown>
  <DropdownToggle style={{fontWeight:'600',fontSize:'14px'}}
    caret 
  >
    Home
  </DropdownToggle>
  <DropdownMenu dark>
    <DropdownItem >
    <HashLink smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none'}} to='/#mission'>About</HashLink>           
    </DropdownItem>
    <DropdownItem >
    <HashLink smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none'}} to='/#consortium'>Consortium</HashLink>    
    </DropdownItem>

    
    
  </DropdownMenu>
  
</UncontrolledDropdown>
              </NavItem>
              <NavItem>
              <UncontrolledDropdown>
  <DropdownToggle style={{fontWeight:'600',fontSize:'14px'}}
    caret
  >
    Project
  </DropdownToggle>
  <DropdownMenu dark>
    <DropdownItem >
              <HashLink smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none'}} to='/project#summary'>Summary</HashLink>      
    </DropdownItem>
    <DropdownItem >
              <HashLink smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none'}} to='/project#objectives'>Objectives</HashLink>
    </DropdownItem>
    <DropdownItem >
              <HashLink smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none'}} to='/project#workplan'>Workplan</HashLink>
    </DropdownItem>
    
    
  </DropdownMenu>
  
</UncontrolledDropdown>
</NavItem>
              <NavItem>
                <NavLink style={{fontSize:'14px'}}>
                <HashLink className=' btn btn-secondary' id='navitem' smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none',fontWeight:'600'}} to='/partners#partners'>Partners</HashLink>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink style={{fontSize:'14px'}}>
                <HashLink className=' btn btn-secondary' smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none',fontWeight:'600'}} to='/news#news'>Newsroom</HashLink>
                </NavLink>
              </NavItem>
              <NavItem>
              <UncontrolledDropdown>
  <DropdownToggle style={{fontWeight:'600',fontSize:'14px'}}
    caret
  >
    Videos
  </DropdownToggle>
  <DropdownMenu dark>
    <DropdownItem >
              <HashLink smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none'}} to='/videos#project'>Project Videos</HashLink>      
    </DropdownItem>
    <DropdownItem >
              <HashLink smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none'}} to='/videos#interview'>Interview Videos</HashLink>
    </DropdownItem>

    
    
  </DropdownMenu>
  
</UncontrolledDropdown>
</NavItem>
              <NavItem>
              <UncontrolledDropdown>
              <DropdownToggle style={{fontWeight:'600',fontSize:'14px'}} caret>
    Outcomes
  </DropdownToggle>

  <DropdownMenu dark>
    <DropdownItem >
    <NavLink>
              <HashLink smooth offset={() => 100} style={{fontSize:'12px',textDecoration:'none'}}to='/outcomes#publications'>Publications</HashLink>
              </NavLink>
    </DropdownItem>
    <DropdownItem >
    <NavLink>
              <HashLink smooth offset={() => 100} style={{fontSize:'12px',textDecoration:'none'}}to='/outcomes#deliverables'>Public Deliverables</HashLink>
              </NavLink>
    </DropdownItem>
    <DropdownItem >
    <NavLink>
              <HashLink smooth offset={() => 100} style={{fontSize:'12px',textDecoration:'none'}}to='/outcomes#material'>Promotional Material</HashLink>
              </NavLink>
    </DropdownItem>
    
    
  </DropdownMenu>
  </UncontrolledDropdown>
             
              </NavItem>
              <NavItem>
              <NavLink style={{fontSize:'14px'}}>           
                <HashLink className=' btn btn-secondary' smooth offset={() => 100} style={{fontSize:'14px',textDecoration:'none',fontWeight:'600'}} to='/#contact'>Contact</HashLink>
                </NavLink>
              </NavItem>
              
            
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default ExamplesNavbar;
